<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Processos de Pagamento</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Lista de processos de pagamento"
            report-title="Processos de pagamento"
            :initial-page="pagina"
            api-url="processospagamento"
            :fields="fields"
            :pageCollection="'processos_pagamento'"
            :append-params="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="primary" for="numero_pagamento_filter"
                    >Número</label
                  >
                  <input
                    type="text"
                    v-model="numero_pagamento"
                    class="form-control"
                    name="numero_pagamento_filter"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="primary" for="valor_filter">Valor</label>
                  <money
                    ref="money"
                    type="text"
                    v-model="valor"
                    class="form-control"
                    name="valor_filter"
                    v-bind="money"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="primary" for="emenda_filter"
                    >Número da emenda</label
                  >
                  <input
                    type="text"
                    v-model="emenda"
                    class="form-control"
                    name="emenda_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                :to="{ name: 'user_salvar_processospagamento' }"
                class="btn btn-default"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon>
                Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <button
                title="Editar"
                type="button"
                class="btn btn-primary"
                @click="editar(props.rowData)"
              >
                <font-awesome-icon :icon="'edit'"></font-awesome-icon>
              </button>
              <button
                title="Excluir"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash'"></font-awesome-icon>
              </button>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'
import { formatarMoeda } from '@/utils/strings'
import modal from '@/components/common/Modal'

export default {
  name: 'processos-pagamento',
  inject: ["showConfirm"],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      fields: [
        {
          name: 'numero_pagamento',
          title: 'Número',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'valor',
          title: 'Valor',
          dataClass: 'align-middle',
          filterable: true,
          callback(value) {
            return formatarMoeda(Number(value))
          }
        },
        {
          name: 'numero',
          title: 'Número da emenda',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list,
    modal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  computed: {
    filtros() {
      const { numero_pagamento, valor, emenda } = this

      return {
        numero_pagamento,
        valor,
        emenda
      }
    },
    pagina: {
      get() {
        const { processos_pagamento } = this.$store.state.vuetableState
        const { pagina } = processos_pagamento
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'processos_pagamento',
          value: value
        })
      }
    },
    numero_pagamento: {
      get() {
        const { processos_pagamento } = this.$store.state.vuetableState
        const { numero_pagamento } = processos_pagamento.filtros
        return numero_pagamento
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero_pagamento',
          collection: 'processos_pagamento',
          value: value
        })
        this.resetPageStore()
      }
    },
    valor: {
      get() {
        const { processos_pagamento } = this.$store.state.vuetableState
        const { valor } = processos_pagamento.filtros
        return valor
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'valor',
          collection: 'processos_pagamento',
          value: value
        })
        this.resetPageStore()
      }
    },
    emenda: {
      get() {
        const { processos_pagamento } = this.$store.state.vuetableState
        const { emenda } = processos_pagamento.filtros
        return emenda
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'emenda',
          collection: 'processos_pagamento',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    editar(data) {
      const { id } = data
      this.$router.push({
        name: 'user_salvar_processospagamento',
        params: { id }
      })
    },
    excluir(data) {
      const me = this
      const { id } = data

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`processospagamento/${id}`)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Processo de pagamento removido com sucesso!')
            })
            .catch(error => {
              me.$toastr.e(
                'Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!'
              )
            })
        }
      }

      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.numero_pagamento = ''
      this.valor = ''
      this.emenda = ''
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'processos_pagamento',
        value: 1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/processos-pagamento/index.vue